module.exports = __webpack_public_path__ + "img/sectionCover2.c9aa1c78.png";